__turbopack_context__.v({
  "buttons": "AccountCreatedView-module-scss-module__yAdh2W__buttons",
  "container": "AccountCreatedView-module-scss-module__yAdh2W__container",
  "content": "AccountCreatedView-module-scss-module__yAdh2W__content",
  "headline": "AccountCreatedView-module-scss-module__yAdh2W__headline",
  "headlineBody": "AccountCreatedView-module-scss-module__yAdh2W__headlineBody",
  "headlineTitle": "AccountCreatedView-module-scss-module__yAdh2W__headlineTitle",
  "heroSection": "AccountCreatedView-module-scss-module__yAdh2W__heroSection",
  "icon": "AccountCreatedView-module-scss-module__yAdh2W__icon",
  "page": "AccountCreatedView-module-scss-module__yAdh2W__page",
  "primaryButton": "AccountCreatedView-module-scss-module__yAdh2W__primaryButton",
  "section1": "AccountCreatedView-module-scss-module__yAdh2W__section1",
  "title": "AccountCreatedView-module-scss-module__yAdh2W__title",
});
